import React from "react"

import Seo from "../components/seo"
import Layout from "../components/layout"
import Nav from "../components/nav"

import EmailSparkle from "../images/email-sparkle.jpg"
import SparkleSupport from "../images/sparkle-support.jpg"
import Indy from "../images/chat-indy.jpg"
import SparkleSocial from "../images/sparkle-social.jpg"

const contact = () => {
  return (
    <Layout>
      <Seo title="Contact Us - We’re happy to answer any questions you may have, just send us a message and we’ll be sure to get in touch with you as soon as possible." />
      <div className="">
        <div className="nav-wrapper bg__sparkle--black">
          <div className="container">
            <Nav />
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 my-5 text-center">
            <h1 className="pt-lg-2 pt-2 hero__title sparkle-deep-blue sparkle--font__56">
              Contact Us
            </h1>

            <p className="mt-2 hero__description sparkle-deep-blue">
              We’re happy to answer any questions you may have, just send us a
              message and we’ll be sure to get in touch with you as soon as
              possible.
            </p>
          </div>
        </div>
      </div>

      {/* <div className="position-relative py-lg-5 py-2">
        <div className="container ">
          <div className="row justify-content-center my-lg-5 my-2">
            <div className="col-lg-5 position-relative my-3">
              <div className="sparkle__card--fluid p-lg-5 p-4 fluid__left">
                <div className="pill mb-4">Email</div>
                <h4 className="sparkle-deep-blue sparkle--mont__900 sparkle--font__36">
                  info@sparkle.ng
                </h4>

                <p className="sparkle--color__light sparkle--font__18 my-4 mx-lg-1">
                  With our game-changing technology, we help financial
                  institutions, SMEs, corporates and merchants, access the
                  simplest financial technology ever. Contact us via the email
                  above for possible collaborations.
                </p>

                <a
                  href="mailto:info@sparkle.ng"
                  className="btn sparkle--button__green mb-4 px-4"
                >
                  Send Us A Mail
                </a>
              </div>
            </div>

            <div className="col-lg-7 order-first order-lg-last my-3">
              <img
                src={EmailSparkle}
                className="img-fluid position-relative rounded-16"
                alt="We share common trends, ideas, happens in the world of finance and lifestyle"
                title="We share common trends, ideas, happens in the world of finance and lifestyle"
              />
            </div>
          </div>
        </div>
      </div> */}

      <div className="position-relative pt-5">
        <div className="container py-lg-5 py-3">
          <div className="row">
            <div className="col-lg-7 my-3">
              <img
                src={SparkleSupport}
                className="img-fluid position-relative rounded-16"
                alt="Join the conversation and get the latest on news and happening in Sparkle"
                title="Join the conversation and get the latest on news and happening in Sparkle"
              />
            </div>

            <div className="col-lg-5 position-relative my-3">
              <div className="sparkle__card--fluid p-lg-5 p-4 fluid__right">
                <div className="pill mb-4">Email</div>
                <h4 className="sparkle-deep-blue sparkle--mont__900 sparkle--font__36">
                  Support@sparkle.ng
                </h4>

                <p className="sparkle--color__light sparkle--font__18 my-4 mx-lg-1">
                  We want to hear from you! Got any questions or issues related to your Sparkle transactions? Our friendly customer experience team is always happy to help.
                </p>

                <a
                  href="mailto:support@sparkle.ng"
                  className="btn sparkle--button__green mb-4 px-4"
                >
                  Contact Support
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="position-relative py-lg-5 py-2">
        <div className="container ">
          <div className="row justify-content-center my-lg-5 my-2">
            <div className="col-lg-5 position-relative my-3">
              <div className="sparkle__card--fluid p-lg-5 p-4 fluid__left">
                <div className="pill mb-4">In App</div>
                <h4 className="sparkle-deep-blue sparkle--mont__900 sparkle--font__36">
                  Chat with Indy
                </h4>

                <p className="sparkle--color__light sparkle--font__18 my-4 mx-lg-1">
                  Ask Indy, your financial buddy on the App. Indy is our
                  intuitive and ever-learning chatbot that can answer all
                  frequently asked questions on the Sparkle app. Simply tap on
                  the chat with Indy button on the home screen of your Sparkle
                  app and ask her any of your Sparkle related questions.
                </p>

                <a
                  href="https://help.sparkle.ng/support/tickets/new"
                  target="_blank"
                  rel="noreferrer"
                  className="btn sparkle--button__green mb-4 px-4"
                  title="chat with indy"
                >
                  Start Chat
                </a>
              </div>
            </div>

            <div className="col-lg-7 my-3 order-first order-lg-last">
              <img
                src={Indy}
                className="img-fluid position-relative rounded-16"
                alt="We share common trends, ideas, happens in the world of finance and lifestyle"
                title="We share common trends, ideas, happens in the world of finance and lifestyle"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="payment position-relative pt-5">
        <div className="container py-lg-5 py-3">
          <div className="row">
            <div className="col-lg-7 my-3">
              <img
                src={SparkleSocial}
                className="img-fluid position-relative rounded-16"
                alt="Join the conversation and get the latest on news and happening in Sparkle"
                title="Join the conversation and get the latest on news and happening in Sparkle"
              />
            </div>

            <div className="col-lg-5 position-relative my-3">
              <div className="sparkle__card--fluid p-lg-5 p-4 fluid__right">
                <div className="pill mb-4">Social</div>
                <h4 className="sparkle-deep-blue sparkle--mont__900 sparkle--font__36">
                  Social Media Account
                </h4>

                <ul className="list-unstyled social">
                  <li className="my-4">
                    <a
                      href="https://www.facebook.com/sparkleplaceng"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                  <li className="my-4">
                    <a
                      href="https://www.instagram.com/sparklenigeria/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Instagram
                    </a>
                  </li>
                  <li className="my-4">
                    <a
                      href="https://www.linkedin.com/company/sparkle-nigeria/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Linkedin
                    </a>
                  </li>
                  <li className="my-4">
                    <a
                      href="https://twitter.com/sparkle_nigeria"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {" "}
                      Twitter
                    </a>
                  </li>
                  <li className="my-4">
                    {" "}
                    <a
                      href="https://www.youtube.com/channel/UCJjqjOITepojplnYOhplbBw"
                      target="_blank"
                      rel="noreferrer"
                    >
                      YouTube
                    </a>
                  </li>
                </ul>

                <a
                  href="https://www.youtube.com/channel/UCJjqjOITepojplnYOhplbBw"
                  target="_blank"
                  rel="noreferrer"
                  className="btn sparkle--button__green mb-4 px-4"
                >
                  See Our Events
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default contact
